import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/fn/fn-goal-3.jpg'
import _imports_1 from '@/assets/images/fn/fn-goal-6.jpg'
import _imports_2 from '@/assets/images/fn/fn-goal-8.jpg'
import _imports_3 from '@/assets/images/fn/fn-goal-11.jpg'
import _imports_4 from '@/assets/images/fn/fn-goal-12.jpg'


const _withScopeId = n => (_pushScopeId("data-v-d511e788"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RichText" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Som en ekstra gevinst ved kortlægning af ressourcer og miljøproblematiske stoffer i forbindelse med nedbrydningen af en bygning, bidrager dette arbejde også til opfyldelse af en række af FN's 17 bæredygtighedsmål. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Intro" }, " Her nævnes de positive effekter, som en kortlægning har på FNs bæredygtighedsmål.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Row" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("div", { class: "Info" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Mål 3 - Sundhed og trivsel"),
    /*#__PURE__*/_createElementVNode("p", null, " Ved at identificere miljøproblematiske stoffer kan der sikres korrekt håndtering og bortskaffelse af disse. Dette mindsker håndværkere og andres eksponering for farlige stoffer, hvilket er med til at nedbringe antallet af sygdomstilfælde og dødsfald. ")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Row" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("div", { class: "Info" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Mål 6 - Rent vand og sanitet"),
    /*#__PURE__*/_createElementVNode("p", null, " Ved at kortlægge en bygnings materialer og udregne dens potentiale for genbrug og genanvendelse vil behovet for udvinding af jomfruelige materialer falde, hvilket fører til bedre beskyttelse af drikkevandet. Samtidig vil korrekt bortskaffelse af affald, der indeholder miljøproblematiske stoffer, mindske risikoen for forurening af vandmiljøet, herunder grundvandet, markant. ")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Row" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("div", { class: "Info" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Mål 8 - Anstændige jobs og økonomisk vækst"),
    /*#__PURE__*/_createElementVNode("p", null, " En ressourcekortlægning af bygninger til nedbrydning er med til at muliggøre genbrug og genanvendelse af bygningsdele, hvilket skaber forretningsmuligheder. "),
    /*#__PURE__*/_createElementVNode("p", null, "En kortlægning af miljøproblematiske stoffer i bygninger, der skal nedbrydes, er med til at sikre gode arbejdsvilkår for de medarbejdere, der skal foretage nedbrydningen, og giver dem mulighed for at anvende de rigtige metoder og de bedste værnemidler.")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Row" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createElementVNode("div", { class: "Info" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Mål 11 - Bæredygtige byer og lokalsamfund"),
    /*#__PURE__*/_createElementVNode("p", null, " Ressourcekortlægning af bygninger til nedbrydning giver mulighed for, at bygningsdele kan genbruges og genanvendes lokalt og dermed sikre et mere bæredygtige lokalsamfund. "),
    /*#__PURE__*/_createElementVNode("p", null, "Når miljøproblematisk affald håndteres korrekt, vil det mindske spredning samt belastning af miljøet.")
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Row" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }),
  /*#__PURE__*/_createElementVNode("div", { class: "Info" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Mål 12 - Ansvarligt forbrug og produktion"),
    /*#__PURE__*/_createElementVNode("p", null, " Ved at kortlægge bygningens ressourcer, gives der mulighed for, at bygningsdele kan genbruges og genanvendes som erstatning for udnyttelse af jomfruelige materialer. Dermed er der mulighed for at udnytte og fastholde værdien af byggematerialerne mange år endnu. "),
    /*#__PURE__*/_createElementVNode("p", null, " Da miljøproblematiske stoffer kortlægges samtidigt, sikres det at disse udfases og fjernes fra den cirkulære økonomi. ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaneTitle = _resolveComponent("PaneTitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PaneTitle, { paneID: 'child' }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.index) + ". FN's bæredygtighedsmål", 1)
      ]),
      _: 1
    }),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8
  ]))
}